import licensesModalStyle from '../../css/licenses-modal.module.css';

import LinkerWithA from 'components/LinkerWithA';
import DropdownWithAdvancedSearch from 'components/DropdownWithAdvancedSearch';

import { useTranslation } from "react-i18next";

import licensesService from "../../service";

import { cloneDeep, isNil } from "lodash";

const AssignToSearchOrgInput = ({
  searchInputKey,
  setSearchInputKey,
  styleClass
}) => {
  const { t } = useTranslation();

  const searchOrg = async (value) => {
    // dispatch(uiActions.showSpinner());
    let param = {
      search: searchInputKey.org,
      data: searchInputKey.orgOptions,
    };
    if (isNil(value)) {
      param.search = { name: "", total: 0 };
      param.data = [];
    } else {
      param.search = { name: value, total: 0 };
      param.data = [];
    }

    const res = await licensesService.searchOrgOption(param);
    const copy = cloneDeep(searchInputKey);
    copy.org = res.search;
    copy.orgOptions = res.data;
    setSearchInputKey(copy);
    // dispatch(uiActions.hideSpinner());
  };

  const getMoreOrg = async () => {
    // dispatch(uiActions.showSpinner());
    let param = {
      search: searchInputKey.org,
      data: searchInputKey.orgOptions,
    };
    const res = await licensesService.searchOrgOption(param);
    const copy = cloneDeep(searchInputKey);
    copy.orgOptions = res.data;
    setSearchInputKey(copy);
    // dispatch(uiActions.hideSpinner());
  };

  return (
    <div className={licensesModalStyle[styleClass]}>
      <div className="modal-form-title required">{t('c1ca926603')}</div>
      <DropdownWithAdvancedSearch
        type={'search'}
        value={searchInputKey?.org?.name}
        buttonIcon={'enter'}
        dataBsToggleOnInput={true}
        // isInvalid={isNil(searchInputKey?.org?.id)}
        onChange={e => {
          const copy = cloneDeep(searchInputKey);
          copy.org.name = e.target.value;
          setSearchInputKey(copy);
        }}
        onClick={e => {
          searchOrg(null);
          const copy = cloneDeep(searchInputKey);
          copy.org.name = '';
          setSearchInputKey(copy);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            searchOrg(e.target.value);
          }
        }}
        buttonOnClick={(e) => {
          searchOrg(searchInputKey.org.name);
          e.stopPropagation();
        }}
      >
        <div className='more-org'>
          <div className='show-more-info' style={styleClass === 'active-license-key-content' ? { width: '255px' } : {}}>
            {`${t("3a6d32cc65", { "count": searchInputKey?.orgOptions?.length })} ${searchInputKey?.org?.total
              } ${t("cfb453439b")}.`}
          </div>
          <LinkerWithA
            label={t('2a725a2a3d')}
            href="#"
            className="linker-blue show-more text-decoration-underline"
            onClick={e => {
              getMoreOrg();
              e.preventDefault();
              e.stopPropagation();
            }}
          ></LinkerWithA>
        </div>
        {searchInputKey?.orgOptions?.map((item, index) => {
          return (
            <li
              key={index}
              className="search-org-item"
              onClick={() => {
                // e.preventDefault();
                const copy = cloneDeep(searchInputKey);
                copy.org.name = item.name;
                copy.org.id = item.id;
                setSearchInputKey(copy);
              }}
            >
              {item.name}
            </li>
          );
        })}
      </DropdownWithAdvancedSearch>
    </div>
  );
};

export default AssignToSearchOrgInput;